export default "__VITE_ASSET__LDaNw0hF__"